/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import { useTrust } from "../../../lib/context/TrustContext";
import PaymentAdvice from "./PaymentAdvice";
import { API, get } from "../../../config";
import ReceiptTemplate from "./ReceiptTemplate";
import EmailConsent from "./EmailConsent";
import { useOrganization } from "../../../lib/context/OrganisationContext";

const TemplateSettings = ({ org = false }) => {
  const { organizationData } = useOrganization();
  const tabsKey = org
    ? [
        {
          name: "Email Consent",
          tabName: "email-consent",
          value: 3,
        },
      ]
    : [
        {
          name: "Remittance Advice",
          tabName: "payment-advice",
          value: 1,
        },
        {
          name: "Receipt Title",
          tabName: "receipt",
          value: 2,
        },
        {
          name: "Email Consent",
          tabName: "email-consent",
          value: 3,
        },
      ];
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab =
    query.get("childTab") || org ? "email-consent" : "payment-advice";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const [templateData, setTemplateData] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { trustId } = useTrust();

  const fetchTemplateData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await get(
        org
          ? `${API.TEMPLATE_DETAILS}/${
              organizationData?.organizationId
                ? organizationData?.organizationId
                : ""
            }?type=organization`
          : `${API.TEMPLATE_DETAILS}/${trustId}?type=trust`,
      );
      setTemplateData(data?.data);
      setLoading(false);
    } catch (e) {
      setTemplateData("");
      setLoading(false);
    }
  }, [trustId]);

  useEffect(() => {
    fetchTemplateData();
  }, [fetchTemplateData]);

  useEffect(() => {
    if (!org) {
      navigate(
        `/trusts/${trustId}/trust-general-settings?tab=template&childTab=${
          tabsKey?.find((item) => item?.value === activeTab)?.tabName
        }`,
        {
          replace: true,
        },
      );
    }
  }, [activeTab, navigate, org, tabsKey, trustId]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab, tabsKey]);

  return (
    <>
      <MainBody search={false} loading={loading} innerBody={true}>
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative p-0 border-none`}
        >
          {activeTab === 1 ? (
            <PaymentAdvice
              templateData={templateData?.payment_advice}
              fetchTemplateData={fetchTemplateData}
              setLoading={setLoading}
              trustId={trustId}
            />
          ) : activeTab === 2 ? (
            <ReceiptTemplate
              templateData={templateData?.receipt}
              receipt_template_type={templateData?.receipt_template_type}
              fetchTemplateData={fetchTemplateData}
              setLoading={setLoading}
              trustId={trustId}
            />
          ) : activeTab === 3 ? (
            <EmailConsent
              templateData={templateData?.email_consent}
              fetchTemplateData={fetchTemplateData}
              setLoading={setLoading}
              trustId={trustId}
              org={org}
            />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default TemplateSettings;
